import {
    PropsWithChildren,
    createContext,
    useContext,
    useEffect,
    useState
} from "react";

import { ProductKeys } from "@atlassiansox/asc-stargate";

import { useSitesContext } from "@/components/sites-provider";

export type LicenseContextType = {
    hasJsmLicense?: boolean;
    hasJpdLicense?: boolean;
};

export const LicenseContext = createContext<LicenseContextType | null>(null);

export const useLicenseContext = () => {
    const context = useContext(LicenseContext);

    if (!context) {
        throw new Error(
            "useLicenseContext must be used within a LicenseContextProvider"
        );
    }

    return context;
};

export const LicenseContextProvider = ({
    children
}: PropsWithChildren<unknown>) => {
    const [hasJsmLicense, setHasJsmLicense] = useState<boolean | undefined>(
        undefined
    );
    const [hasJpdLicense, setHasJpdLicense] = useState<boolean | undefined>(
        undefined
    );
    const { sites } = useSitesContext();

    useEffect(() => {
        if (sites !== undefined) {
            const hasJSM = sites.find((site) =>
                site.products.some(
                    (product) => product === ProductKeys.JIRA_SERVICE_DESK
                )
            );
            const hasJPD = sites.find((site) =>
                site.products.some(
                    (product) => product === ProductKeys.JIRA_PRODUCT_DISCOVERY
                )
            );
            setHasJsmLicense(!!hasJSM);
            setHasJpdLicense(!!hasJPD);
        }
    }, [sites]);

    return (
        <LicenseContext.Provider value={{ hasJsmLicense, hasJpdLicense }}>
            {children}
        </LicenseContext.Provider>
    );
};
